/* unplugin-vue-components disabled */import script from "./HotelTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelTable.vue?vue&type=script&setup=true&lang=js"

import "./HotelTable.vue?vue&type=style&index=0&id=1a0e9f84&lang=css"

const __exports__ = script;

export default __exports__